import { MDBBtn, MDBInput, MDBModalFooter, MDBTypography } from 'mdb-react-ui-kit';
import React, { forwardRef, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { creatCallBlocking, editCallBlocking } from '../../../apiclients/streamsapi_bridge';
import PopupLoader from '../PopupLoader';
import { formattedNumber, unFormatNumber } from '../phonenumbers/AddRemoveNumbers';
import SwitchCallBlockingNum from './SwitchCallBlockingNum';
import { normalizePhoneNumber } from '../../../apiclients/CommonUtils';

const AddRemoveNum = forwardRef((props, ref) => {
    const [defaultValuess, setDefaultValuess] = useState({});
    const [rowuniqueid, setRowUniqueId] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [createFlag, setCreateFlag] = useState(false);
    const [updateObj, setUpateObj] = useState({});
    const [switchNumber, setSwitchNumber] = useState(false);
    const toggleSwitch = () => setSwitchNumber(!switchNumber);
    const [formObj, setformObj] = useState({});
    const { t, i18n } = useTranslation();
    const { register, handleSubmit, setValue, getValues, formState: { errors, isDirty, dirtyFields }, setError, reset } = useForm({
        defaultValues: {
            phnum: "",
            comment: ""
        }
    })
    useEffect(() => {
        if (props.ListObj && Object.keys(props.ListObj).length > 0) {
            setDefaultValuess({
                phnum: unFormatNumber(props.ListObj.ph_number) ?? "",
                comment: props.ListObj.comment ?? "",
            });
            setRowUniqueId(props.ListObj.id);
        }

    }, [props.ListObj]);

    useEffect(() => {
        if (defaultValuess && Object?.keys(defaultValuess)?.length > 0) {
            reset(defaultValuess)
        }

    }, [defaultValuess])

    const onsubmit = async (data) => {
        if (props.editEnable) {
            if (isDirty) {
                let update = {
                    reqid: 54,
                    siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                    unique_id: rowuniqueid
                }
                for (const field of Object.keys(dirtyFields)) {
                    if (field == 'phnum') {
                        update[props.fieldname] = data.phnum.length === 10 ? `1${data.phnum}` : data.phnum
                    }
                    if (field == 'comment') {
                        update.comment = data.comment
                    }

                }

                let saverep = await editCallBlocking(update);
                let saverepeMsg = await saverep.json();
                console.log("Reponse for update  call blocking ::::: " + JSON.stringify(saverepeMsg));

                if (saverepeMsg.status && saverepeMsg.status === "success") {
                    const createdDate = saverepeMsg.created_date ?? "";
                    props.setSuccessMessage(saverepeMsg.message);
                    const modifiedObj = {
                        unique_id: rowuniqueid,
                        created_date: createdDate,
                        comment: data.comment,
                        ph_number: formattedNumber(data.phnum),
                        isEdited: true,
                    }
                    props.modifiedObj(modifiedObj);
                    props.modifyFlag(true);
                    props.onClose();

                } else {
                    displaySeverError(saverepeMsg, update, false, data);

                }

            }
        } else {
            let update = {
                reqid: 53,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                [props.fieldname]: data.phnum.length === 10 ? `1${data.phnum}` : data.phnum,
                comment: data.comment
            }

            console.log(" create white and black  " + JSON.stringify(update))
            let saverep = await creatCallBlocking(update);

            let saverepeMsg = await saverep.json();
            console.log("reposnse of add :::::::" + JSON.stringify(saverepeMsg));

            if (saverepeMsg.status && saverepeMsg.status == "success") {
                const rowid = saverepeMsg.unique_id ?? "";
                const createdDate = saverepeMsg.created_date ?? "";
                const modifiedObj = {
                    unique_id: rowid,
                    created_date: createdDate,
                    comment: data.comment,
                    ph_number: formattedNumber(data.phnum),
                }
                props.setSuccessMessage(saverepeMsg.message);
                props.modifiedObj(modifiedObj);
                props.modifyFlag(true);
                props.onClose();

            } else {
                displaySeverError(saverepeMsg, update, true, data);
            }
        }
    }

    function displaySeverError(saverepeMsg, updateObj, isCreate, data) {
        if (saverepeMsg.message?.errors) {
            saverepeMsg.message.errors.forEach((err) => {
                   if (err.switchFlag && err.shiftFlag) {
                    setErrorMessage(err.message);
                    setUpateObj(updateObj);
                    setCreateFlag(isCreate);
                    setformObj(data);
                    toggleSwitch();
                } else {
                    const paramName = (err.param_name == 'whitelist_phnum' || err.param_name == 'blacklist_phnum') ? 'phnum' : err.param_name;
                    setError(paramName, {
                        type: "server",
                        message: err.message,
                    });
                }
            });
        }
    }

    return (

        <>
            <div className='addwhitelistInput'>
                <strong>Phone Number</strong>
                <div className='form-outline w-100 mb-2' >

                    <input type='text' className='form-control w-100'
                        maxLength={props.fieldname === "blacklist_phnum" ? 16 : 15}
                        onKeyPress={(event) => {
                            const inputValue = event.key;
                            const currentValue = event.target.value;
                            // Check if the input is not a number, '*', '+', or space
                            if (!/[\d*+\s]/.test(inputValue)) {
                                event.preventDefault();
                            } else if (inputValue === '*' && currentValue.includes('*')) {
                                // Check if '*' already exists in the input
                                event.preventDefault();
                            } else if (
                                inputValue === '+' &&
                                (currentValue !== '' || currentValue.includes('+'))
                            ) {
                                // Check if '+' is already in the input or trying to add '+' at a position other than the start
                                event.preventDefault();
                            }
                        }}
                        {...register("phnum" , {
                            onChange:normalizePhoneNumber
                        })}
                    />
                    {(errors.phnum || errors.whitelist_phnum || errors.blacklist_phnum) && (
                             <p className="text-danger">
                               {errors.phnum?.message ||
                                     errors.whitelist_phnum?.message ||
                                        errors.blacklist_phnum?.message}
                              </p>
                   )}
                </div>
            </div>
            <div>
                {/* <div>
                    <MDBTypography className='text-secondary' tag='small'>Enter a valid Telephone number.</MDBTypography>
                </div> */}
                <MDBTypography className='text-secondary' tag='small'></MDBTypography>
            </div>

            <label className='mt-2'> Comments</label>
            <MDBInput  {...register("comment")} />
            {errors.comment && (
                <p className="text-danger">{errors.comment.message}</p>)}

            <div style={{ display: "none" }}>
                <button ref={ref} onClick={handleSubmit(onsubmit)}>
                    {props.editEnable ? 'Save' : 'Add'}</button>
            </div>

            {/* <MDBModalFooter>
                <MDBBtn color='secondary' onClick={(e) => props.onClose(e)}>
                    Cancel
                </MDBBtn>
                {isDirty && (
                    <MDBBtn onClick={handleSubmit(onsubmit)}>{props.editEnable ? 'Save' : 'Add'}</MDBBtn>
                )}
            </MDBModalFooter> */}

            {switchNumber && (
                <PopupLoader
                    size="md"
                    className="small-popup"
                    title={t("Confirmation")}
                    content={
                        <SwitchCallBlockingNum
                            onClose={toggleSwitch}
                            errorMessage={errorMessage}
                            updateObj={updateObj}
                            createFlag={createFlag}
                            formObj={formObj}
                            modifiedObj={props.modifiedObj}
                            modifyFlag={props.modifyFlag}
                            closeMain={props.onClose}
                            displaySeverError={displaySeverError}
                            setSuccessMessage={props.setSuccessMessage}
                        />
                    }
                    onShow={setSwitchNumber}
                    onClose={toggleSwitch}
                />
            )}
        </>
    )
});

export default AddRemoveNum;
